module.exports = __webpack_public_path__ + "img/Heavy Rain.5397f234.png";